// extracted by mini-css-extract-plugin
module.exports = {"failure":"Submissions__failure___3_DBp","body":"Submissions__body___1UGpY","id":"Submissions__id___3O2t4"};